import { render, staticRenderFns } from "./pelunasanmemofrm.vue?vue&type=template&id=895b4884&"
import script from "./pelunasanmemofrm.vue?vue&type=script&lang=js&"
export * from "./pelunasanmemofrm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports